/* tslint:disable */
/* eslint-disable */
/**
 * Survey
 * 現地調査用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostCostcoProductsRequestCostcoProduct } from './PostCostcoProductsRequestCostcoProduct';
import {
    PostCostcoProductsRequestCostcoProductFromJSON,
    PostCostcoProductsRequestCostcoProductFromJSONTyped,
    PostCostcoProductsRequestCostcoProductToJSON,
} from './PostCostcoProductsRequestCostcoProduct';

/**
 * 
 * @export
 * @interface PostCostcoProductsRequest
 */
export interface PostCostcoProductsRequest {
    /**
     * 
     * @type {PostCostcoProductsRequestCostcoProduct}
     * @memberof PostCostcoProductsRequest
     */
    costcoProduct: PostCostcoProductsRequestCostcoProduct;
}

/**
 * Check if a given object implements the PostCostcoProductsRequest interface.
 */
export function instanceOfPostCostcoProductsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "costcoProduct" in value;

    return isInstance;
}

export function PostCostcoProductsRequestFromJSON(json: any): PostCostcoProductsRequest {
    return PostCostcoProductsRequestFromJSONTyped(json, false);
}

export function PostCostcoProductsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCostcoProductsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'costcoProduct': PostCostcoProductsRequestCostcoProductFromJSON(json['costco_product']),
    };
}

export function PostCostcoProductsRequestToJSON(value?: PostCostcoProductsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'costco_product': PostCostcoProductsRequestCostcoProductToJSON(value.costcoProduct),
    };
}

